import { SAVE_DRAFT_MESSAGE } from '../constants/chat';

export function saveDraftMessage({ id, text }) {
  return {
    type: SAVE_DRAFT_MESSAGE,
    payload: { id, text },
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/actions/chat.js